import { useState } from "react";

import { Button } from "@components/Button";
import { Checkbox } from "@components/Checkbox";
import { Dialog, DialogContent } from "@components/Dialog";
import { Image } from "@components/Image";
import { Stack } from "@components/Stack";
import { Typography } from "@components/Typography";

import { isShowPostSentModerationDialogStorage } from "@storage/localStorage";

import { ICON_PATHS } from "@configs/icons";

export type PostSentToModerationDialogProps = {
	onClose: () => void;
};

export const PostSentToModerationDialog = ({ onClose }: PostSentToModerationDialogProps) => {
	const [showAgain, setShowAgain] = useState(false);

	const handleShowAgain = (checked: boolean | "indeterminate") => {
		const isChecked = checked === true;
		setShowAgain(isChecked);

		if (isChecked) {
			isShowPostSentModerationDialogStorage.setItem("true");
		}
	};

	return (
		<Dialog open onOpenChange={(open) => !open && onClose()}>
			<DialogContent className="w-[320px] max-w-[calc(100vw-32px)] p-6">
				<Image width={100} height={70} className="mx-auto block h-17.5 w-25" src={ICON_PATHS.CONFIRM} alt="upload" />
				<Typography type="p" weight="bold" align="center">
					Post sent for moderation
				</Typography>

				<Stack direction="row" align="center" justify="center" spacing={16} className="mt-4">
					<Checkbox id="dont-show-again-post" checked={showAgain} onCheckedChange={handleShowAgain} />
					<label htmlFor="dont-show-again-post" className="cursor-pointer">
						<Typography type="p" align="center" padding="none">
							don&apos;t show again
						</Typography>
					</label>
				</Stack>
				<div className="mt-4">
					<Button wide onClick={onClose}>
						<Typography type="p" padding="none" weight="bold" size="sm">
							Go back
						</Typography>
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};
